<template>
    <div class="toggle" v-disabled="disabled">
        <btn v-for="(option, index) in computedOptions"
             :key="index"
             theme="none"
             :label="option[labelKey]"
             class="option"
             v-c:selected="option[valueKey] == value"
             @click.prevent="$emit('input', option[valueKey])"
        />
    </div>
</template>

<script>
    export default {
        props: {
            value: {require: true},
            options: [String, Array],
            valueKey: {type: String, default: 'key'},
            labelKey: {type: String, default: 'label'},
            disabled: {type: Boolean, default: false},
        },

        computed: {
            computedOptions() {
                let options = this.options;

                if (typeof options === "string") {
                    if (!this.$store.getters.hasOwnProperty(options)) {
                        throw `Unknown vuex getter: ${options}`;
                    }
                    options = this.$store.getters[options];
                }

                if (!Array.isArray(options)) {
                    throw 'Prop options have to be an array or valid vuex getter';
                }

                if (options.length > 0 && ["string", "number"].includes(typeof options[0])) {
                    return options.map(option => ({key: option, label: option}));
                }

                return options;
            },
        },

        methods: {
            selectOption(option) {
                this.$emit('input', option[this.valueKey]);
                this.open = false;
            },
        },
    };
</script>